import { useVisibilityState } from '@lbcamden/lib-react';
import { useCallback, useState } from 'react';

import { PcfraPerson } from '~/common/types/people';

import { ReconfirmSuitabilityDialog } from './ReconfirmSuitabilityDialog';

export const useReconfirmSuitabilityDialog = () => {
  const [person, setPerson] = useState<PcfraPerson>();

  const { show, hide, visible } = useVisibilityState();

  const showReconfirmSuitabilityDialog = useCallback((selectedPerson: PcfraPerson) => {
    setPerson(selectedPerson);
    show();
  }, []);

  return {
    showReconfirmSuitabilityDialog,
    reconfirmSuitabilityDialog: (
      <ReconfirmSuitabilityDialog open={visible} person={person} onClose={hide} />
    ),
  };
};
